"use client"
import { StarRating } from "@/components/atoms"
import { useTranslate } from "@tolgee/react"

export const ProductReviewScore = ({
  rate,
  reviewCount,
}: {
  rate: number
  reviewCount: number
}) => {
  const { t } = useTranslate()
  return (
    <div className="flex flex-col items-center justify-center gap-2 h-full px-6 py-10">
      <p className="text-xs text-[#717182]">{t("product_score.product_score")}</p>
      <p className="text-4xl font-light text-[#0a0a0a] leading-10 tracking-[-0.53px]">{rate.toFixed(1)}</p>
      <StarRating rate={rate} starSize={14} />
      <p className="text-xs text-[#717182] pt-1">{reviewCount} {t("product_score.reviews")}</p>
    </div>
  )
}
